
import { EventType } from '@/lib/types';
import { Tag } from 'lucide-react';
import { eventTypeLabels } from '@/lib/eventLabels';
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface FilterTypesProps {
  selectedTypes: EventType[];
  onTypeClick: (type: EventType) => void;
}

const FilterTypes = ({ selectedTypes, onTypeClick }: FilterTypesProps) => {
  const typeOptions = Object.entries(eventTypeLabels) as [EventType, string][];

  const handleTypeToggle = (type: EventType) => {
    onTypeClick(type);
  };

  return (
    <div className="px-4 pb-4">
      <div className="flex items-center text-sm font-medium text-gray-600 mb-2">
        <Tag size={16} className="mr-1 text-medihub-primary" />
        <span>Esemény típusa</span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {typeOptions.map(([type, label]) => (
          <button
            key={type}
            onClick={() => handleTypeToggle(type)}
            className={`
              px-3 py-1.5 text-sm rounded-md transition-all duration-200
              border border-gray-200 
              ${selectedTypes.includes(type) 
                ? 'bg-medihub-primary text-white font-medium shadow-sm border-medihub-primary' 
                : 'bg-white text-gray-700 hover:bg-gray-100 hover:border-gray-300'}
            `}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterTypes;
